let down = [
  {
    path: '/lyntx',
    component: () => import(/* webpackChunkName: "lyntx" */ '@/pages/lyntx/index.vue'),
    meta: {
      title: '信用飞',
    },
  }
];

export default down;